module.exports = __webpack_public_path__ + "img/index7.bd9be0a6.png";